import React, { Component, PropTypes } from 'react'
import AutoComplete from 'material-ui/AutoComplete'

import { userEmailHydrator } from '../../../../fieldOptions/hydrators'

import api from '../../../../api'

const dataSourceConfig = {
  text: 'displayVal',
  value: 'id'
}

class UserSelect extends Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      dataSource: []
    }
  }

  handleSelection = (user, index) => {
    if (index === -1) {
      return
    }
    this.props.onSelection(user)
  }

  handleUpdateInput = (searchText) => {
    if (searchText === '') {
      this.setState({ dataSource: [] })
      return this.props.onSelection(null)
    }

    const body = {
      filters: {
        fullname_ilike: searchText
      },
      limit: 20,
      order: [{
        column: 'name',
        direction: 'asc'
      }]
    }

    api.get(`admin/institutions/${this.props.institutionId}/users`, { body })
      .then(res => res.json())
      .then(users => {
        this.setState({ dataSource: userEmailHydrator(users) })
      })
  }

  render () {
    const { dataSource } = this.state
    const { errorText } = this.props

    return (
      <AutoComplete
        dataSource={dataSource}
        dataSourceConfig={dataSourceConfig}
        errorText={errorText}
        floatingLabelText='Name'
        filter={() => true}
        onNewRequest={this.handleSelection}
        onUpdateInput={this.handleUpdateInput}
      />
    )
  }
}

// @ts-ignore
UserSelect.propTypes = {
  errorText: PropTypes.string,
  onSelection: PropTypes.func.isRequired,
  institutionId: PropTypes.number.isRequired
}

export default UserSelect
